import { TooltipContent } from '@trellis/roots/tooltip'
import { describeReminderOffset } from '@trellis/shared'

import type { ReminderMarkDotKind } from './ReminderMarkDot'
import {
  REMINDER_MARK_DOT_DESCRIPTIONS,
  REMINDER_MARK_DOT_LABELS,
} from './reminders.constants'

/** "7 days before the due date" capitalised for a tooltip line. */
export function describeReminderOffsetSentence(daysRelativeToDue: number): string {
  const offset = describeReminderOffset(daysRelativeToDue)
  return offset.charAt(0).toUpperCase() + offset.slice(1)
}

/**
 * Tooltip body for a reminder dot: what it is, when it happens (`detail`) and what it
 * does. `hint` adds an extra line, e.g. how to move the dot.
 */
export function ReminderMarkTooltipContent({
  kind,
  detail,
  hint,
}: {
  kind: ReminderMarkDotKind
  detail: string
  hint?: string
}) {
  return (
    <TooltipContent className="flex max-w-64 flex-col gap-0.5">
      <span className="font-semibold">{REMINDER_MARK_DOT_LABELS[kind]}</span>
      <span>{detail}</span>
      <span className="opacity-80">{REMINDER_MARK_DOT_DESCRIPTIONS[kind]}</span>
      {hint && <span className="opacity-70">{hint}</span>}
    </TooltipContent>
  )
}
